import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useLang, COMPANY, MAIN_IMAGE } from "@/lib/i18n";

const SITE_URL = "https://hebteamtrans.com";

/* Centralized SEO: title, description, canonical, Open Graph, Twitter card and JSON-LD. */
export default function SEO({ title, description, path = "/", jsonLd }) {
  const { lang } = useLang();
  const location = useLocation();

  useEffect(() => {
    document.documentElement.lang = lang;
    document.title = title;

    const setMeta = (attr, key, val) => {
      let el = document.head.querySelector(`meta[${attr}="${key}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attr, key);
        document.head.appendChild(el);
      }
      el.setAttribute("content", val);
    };

    const setLink = (rel, href) => {
      let el = document.head.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement("link");
        el.setAttribute("rel", rel);
        document.head.appendChild(el);
      }
      el.setAttribute("href", href);
    };

    const url = `${SITE_URL}${path}`;
    const image = `${SITE_URL}${MAIN_IMAGE}`;

    setMeta("name", "description", description);
    setMeta("name", "robots", "index, follow");
    setLink("canonical", url);

    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:url", url);
    setMeta("property", "og:image", image);
    setMeta("property", "og:locale", lang === "ro" ? "ro_RO" : "en_US");
    setMeta("property", "og:site_name", COMPANY.name);

    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", title);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", image);

    let ldEl = document.getElementById("ld-json");
    if (jsonLd) {
      if (!ldEl) {
        ldEl = document.createElement("script");
        ldEl.type = "application/ld+json";
        ldEl.id = "ld-json";
        document.head.appendChild(ldEl);
      }
      ldEl.text = JSON.stringify(jsonLd);
    } else if (ldEl) {
      ldEl.remove();
    }
  }, [title, description, path, jsonLd, lang, location.pathname]);

  return null;
}
